import React from 'react'
import { connect } from 'react-redux'
import { setIdEstanciaActual, setIdioma } from '../../modules/reducer'

import ImageContainer from '../Images/ImageContainer'
import MenuEstancias from '../MenuEstancias/MenuEstancias'

import { setPositionY } from '../MenuEstancias/MenuScroll'

import queryString from 'query-string'

import TokenParam from './TokenParam'

const Estancia = ({
  location,
  match,
  history,
  setIdEstanciaActual,
  setIdioma
}) => {
  const values = queryString.parse(location.search)

  if (typeof values.token !== 'undefined') {
    return (
      <TokenParam
        token={values.token}
        idioma={values.idioma}
        history={history}
      />
    )
  }

  //ReactGA.pageview(window.location.pathname + window.location.search);

  setIdEstanciaActual(
    match.params.id
    //typeof match.params.id === 'undefined' ? '0' : match.params.id
  )
  setIdioma(
    typeof match.params.idioma === 'undefined' ? 'es' : match.params.idioma
  )

  setPositionY(0)

  return (
    <>
      <ImageContainer history={history} />
      <MenuEstancias />
    </>
  )
}

const mapDispatchToProps = { setIdEstanciaActual, setIdioma }

export default connect(
  null,
  mapDispatchToProps
)(Estancia)
